export const COLORS = {
  bg: "#0C0C0E",
  surface: "#141416",
  surfaceAlt: "#1C1C1F",
  border: "#2C2C31",
  borderLight: "#222226",
  text: "#F0EFE9",
  textSecondary: "#A09D98",
  textMuted: "#6A6764",
  accent: "#E8C872",
  accentLight: "#2A2416",
  accentHover: "#F0D485",
  green: "#4ADE80",
  greenLight: "#0A2018",
  orange: "#FB923C",
  orangeLight: "#281506",
  red: "#F87171",
  redLight: "#280A0A",
  purple: "#A78BFA",
  purpleLight: "#1A1230",
};
